<script setup>
import {ref, watch} from 'vue';

    const props = defineProps({
        defaultClass: {
            type: String,
            required: false,
            default: 'bg-gray-1 h-0.5',
        },
        percentageClass: {
            type: String,
            required: false,
            default: '',
        },
       uploadPercentage: [String, Number],
    });

    const percentage = ref(0 + '%');

    watch(() => props.uploadPercentage, (newValue) => {
        percentage.value = newValue + '%';
    }, {immediate: true});
</script>

<template>
    <div class="w-full relative flex flex-col" :class="defaultClass">
        <div class="bg-primary-1 absolute top-0 left-0 h-full transition-all z-10" :style="{ width: percentage }"></div>
        <div class="pt-1 text-sm z-20" :class="percentageClass" v-text="percentage"></div>
    </div>
</template>

<style scoped>

</style>
